import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class SocialEngagePostPerformanceReport extends ApplicationRecord {
  static jsonapiType = "social_engage_post_performance_reports";

  @Attr() after: string;

  @Attr() before: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr() csv: boolean;

  @Attr() csvUrl: string;

  @Attr() htmlUrl: string;

  @Attr() language: string;

  @Attr() options: Record<string, any>;

  @Attr() organisationTeamId: number;

  @Attr() pdf: boolean;

  @Attr() pdfUrl: string;

  @Attr() sortBy: string;

  @Attr() sortOrder: string;

  @Attr() status: string;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() userId: number;
}

export default SocialEngagePostPerformanceReport;
